<template>
  <div v-if="item">
    <div class="flex">
      <div class="pack w-fit">
        {{ item.label }}
      </div>
    </div>
    <div class="flex flex-col items-center" :class="!item.off && 'mt-6'">
      <span
        class="flex items-center justify-center"
        :class="item.off && 'text-blue-400'"
      >
        <span :class="item.off ? 'line-through decoration-error-700' : 'text-xl font-extrabold'">
          {{ oldFormatPrice(item.price) }}
        </span>
        <span class="ms-1" :class="item.off ? 'text-sm line-through decoration-error-700' : ''">{{ item.type !== 'metama' ? priceType : 'تومان' }}</span>
        <ChipsBase v-if="item.off" variant="error" size="Small" class="mr-2">{{ item.off }}% تخفیف</ChipsBase>
      </span>

      <template v-if="item.off">
        <span class="flex items-center justify-center">
          <span class="ml-1 text-xl font-extrabold">
            {{ getOffPrice(item.price, item.off) }}
          </span>
          <span class="ms-1">{{ item.type !== 'metama' ? priceType : 'تومان' }}</span>
        </span>
      </template>
    

      <div class="text-sm text-center mb-2 mt-4">{{ item.title }}</div>
      <div v-if="item.setupFee" class="text-sm">
        <div class="text-center">+</div>
        <div class="text-center mt-4">
          {{ oldFormatPrice(item.setupFee) }}<span class="ms-1">تومان</span>
        </div>
        <div class="text-center">هزینه راه‌اندازی</div>
      </div>
      <ChipsBase v-else-if="freeSetupChip" variant="purple" size="Small" class="mt-2 mb-2">راه‌اندازی رایگان</ChipsBase>
    </div>

    <slot name="buttons"></slot>
    <div v-if="!slots.buttons" class="mt-4">
      <BaseButton
        isLean
        size="full"
        text="ثبت سفارش"
        @click="showMainModal"
        class="rounded-lg h-[32px]"
        :id="setIdByPath('cta')"
      />
      <NuxtLink v-if="shoppingSrc" :to="shoppingSrc">
        <BaseButton
          size="full"
          text="خرید آنلاین"
          styleType="secondary"
          class="rounded-lg h-[32px] mt-2"
          :id="setIdByPath('onlineShopping')"
        />
      </NuxtLink>
    </div>

    <div v-if="item.options" class="flex flex-col my-4 gap-3">
      <div
        class="flex justify-start text-sm"
        v-for="i in item.options"
        :key="'bo' + i.id"
      >
        <div class="me-2">
          <IconCross v-if="i.notEnabled" class="text-[#FB977D] w-4 h-4" />
          <IconLightTik v-else class="stroke-blue-700 scale-100 ml-2 h-6" />
        </div>
        <div class="text-gray-500">{{ i.title }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSlots } from "vue";

defineProps({
  item: Object,
  shoppingSrc: {
    type: String,
    default: "",
  },
  freeSetupChip: {
    type: Boolean,
    default: false
  },
  priceType: {
    type: String,
    default: "هزار تومان"
  }
});

const { oldFormatPrice } = useInputHelpers();

const getOffPrice = (price, off) => {
  if (Array.isArray(price)) price = price[0];
  const totalPrice = (price * off) / 100;
  const offPrice = Math.floor(price - totalPrice);
  return oldFormatPrice(offPrice);
};

const modalsStore = useModalsStore();

const showMainModal = () => {
  modalsStore.openModal('CTA');
};

const slots = useSlots();
</script>
